"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _ReviewRefuse = _interopRequireDefault(require("@rsuite/icon-font/lib/flow/ReviewRefuse"));

// Generated by script, don't edit it please.
var ReviewRefuse = (0, _createSvgIcon["default"])({
  as: _ReviewRefuse["default"],
  ariaLabel: 'review refuse',
  category: 'flow',
  displayName: 'ReviewRefuse'
});
var _default = ReviewRefuse;
exports["default"] = _default;
module.exports = exports.default;